export default __webpack_public_path__ + "static/media/ewm.32bbdd59.png";